/* eslint-disable import/prefer-default-export */
import {
  colorBlack,
  colorBlue,
  colorGray,
  font,
  getBackgrounColor,
  getColor,
  selectedColor
} from "../../styleConstants";

export const styles = {
  container: provided => ({ ...provided, order: 2 }),
  menuList: provided => ({
    ...provided,
    maxHeight: "180px",
    paddingTop: 0,
    paddingBottom: 0
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: "2px",
    border: "none",
    height: "40px",
    boxShadow: "none",
    borderBottom: `2px solid ${state.isFocused ? colorBlue : selectedColor}`,
    minHeight: "39px"
    // borderBottomColor: !state.hasValue && !state.isDisabled ? "#E46262" : "",
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "15px",
    fontFamily: font,
    fontSize: "18px",
    lineHeight: "22px",
    fontStyle: "normal",
    fontWeight: "300",
    color: state.isSelected ? colorBlue : colorBlack,
    backgroundColor: getBackgrounColor(provided, state)
  }),
  placeholder: provided => ({
    ...provided,
    fontFamily: font,
    fontSize: "15px",
    lineHeight: "22px",
    fontStyle: "normal",
    fontWeight: 300,
    color: colorGray
  }),
  singleValue: (provided, state) => ({
    ...provided,
    opacity: state.isDisabled ? 0.5 : 1,
    transition: "opacity 300ms",
    fontFamily: font,
    fontSize: "15px",
    lineHeight: "22px",
    fontStyle: "normal",
    fontWeight: 300,
    color: colorBlack
  })
};

export const userRoleStyles = {
  menu: provided => ({
    ...provided,
    width: "150%"
  }),
  placeholder: provided => ({
    ...provided,
    fontFamily: font,
    fontSize: "18px",
    lineHeight: "22px",
    fontStyle: "normal",
    fontWeight: 300,
    color: "#C0CCDF"
  }),
  menuList: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "20px",
    fontFamily: font,
    fontSize: "14px",
    lineHeight: "17px",
    fontStyle: "normal",
    fontWeight: "500",
    color: getColor(state),
    backgroundColor: "#F5F9FF"
  })
};
